module.exports = __webpack_public_path__ + "static/media/ml.b7b75bc7.svg";